var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.706 12.1298C19.706 16.4763 16.1824 19.9998 11.836 19.9998C7.48946 19.9998 3.96593 16.4763 3.96593 12.1298C3.96593 7.7833 7.48946 4.25977 11.836 4.25977C16.1824 4.25977 19.706 7.7833 19.706 12.1298Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78558 12.499L4 14L4.46466 14.6969C3.81728 15.4426 3.40256 16.0976 3.20127 16.6194C2.99317 17.1589 3.06612 17.4008 3.1162 17.4876C3.16627 17.5743 3.33929 17.7584 3.91057 17.848C4.47076 17.9357 5.2591 17.902 6.24727 17.7072C8.21337 17.3197 10.7472 16.3397 13.3553 14.8339C15.9634 13.3281 18.079 11.6237 19.3977 10.1148C20.0604 9.35645 20.4838 8.69059 20.6879 8.16156C20.896 7.62205 20.823 7.38014 20.773 7.29341C20.7229 7.20669 20.5499 7.02255 19.9786 6.93302C19.4261 6.84643 18.6517 6.87806 17.6826 7.0658L16.1897 5.35959C16.5556 5.26212 16.9113 5.17927 17.2551 5.11151C18.367 4.89232 19.4101 4.81951 20.2883 4.95714C21.1553 5.09302 22.0275 5.46627 22.505 6.29341C22.9826 7.12056 22.8697 8.0625 22.5539 8.88132C22.234 9.71062 21.6494 10.5776 20.9036 11.4309C19.4052 13.1455 17.1013 14.9806 14.3553 16.5659C11.6093 18.1513 8.8682 19.2291 6.63407 19.6695C5.52212 19.8886 4.47903 19.9615 3.6009 19.8238C2.73387 19.6879 1.8617 19.3147 1.38414 18.4876C0.906591 17.6604 1.01944 16.7185 1.33527 15.8996C1.65515 15.0704 2.23975 14.2034 2.98555 13.35C3.23113 13.069 3.49834 12.7848 3.78558 12.499Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.7ad6764e5240b27a690cd3b1abee7939.svg";
export { ForwardRef as ReactComponent };